"use client";
import { useTranslations } from "next-intl";
import Link from "next/link";
import Blog from "../blog/Blog";
import { MoveRight } from "lucide-react";

export default function LatestBlog() {
  const t = useTranslations("Home");

  return (
    <section className="relative py-24 overflow-hidden bg-[#F7F5F2]">
      {/* Decorative background blobs */}
      <div className="pointer-events-none absolute -top-32 -left-32 w-125 h-125 rounded-full bg-[#E8E0D5]/60 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-20 -right-20 w-95 h-95 rounded-full bg-[#D6CEBC]/50 blur-3xl" />

      <div className="relative sm:container px-4 md:px-0 lg:w-[85%] mx-auto">
        {/* Header */}
        <div className="flex items-end justify-between mb-14">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] font-semibold text-[#9B8E7A] mb-3">
              {t("ourBlog") ?? "المقالات"}
            </p>
            <h2 className="text-4xl md:text-5xl font-black text-[#1C1917] leading-tight">
              {t("latestBlog")}
            </h2>
          </div>

          <Link
            href="/blog"
            className="group hidden sm:flex items-center gap-2 text-sm font-semibold text-[#1C1917] border-b-2 border-[#1C1917]/30 pb-1 hover:border-[#1C1917] transition-all duration-300"
          >
            {t("viewAll")}
            <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">
              <MoveRight size={12}/>
            </span>
          </Link>
        </div>

        <Blog limit={2} />

        {/* Mobile view all */}
        <div className="mt-10 flex sm:hidden justify-center">
          <Link
            href="/blog"
            className="group flex items-center gap-2 text-sm font-semibold text-[#1C1917] border-b-2 border-[#1C1917]/30 pb-1"
          >
            {t("viewAll")}
            <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">
              →
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}
